/* global attachEvent */

// *******************************************************************************
// Close popup
// *******************************************************************************

attachEvent('.popup__close', 'click', (ev) => {
  // eslint-disable-next-line no-undef
  Cookies.set('popup-cookie-seen', 'popup-cookie-set', { expires: 1 });
  ev.target.closest('.popup__wrapper').classList.remove('is-active');
});
